const STATS = [
  { value: "12,000+", label: "影视资源", icon: "ri-film-line" },
  { value: "每日更新", label: "追剧不掉线", icon: "ri-refresh-line" },
  { value: "高清画质", label: "流畅观影", icon: "ri-hd-line" },
  { value: "完全免费", label: "无需注册", icon: "ri-gift-line" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full px-4 py-8 md:px-6 md:py-10 lg:px-10">
      <div className="overflow-hidden rounded-xl border border-background-800 bg-gradient-to-br from-background-900 via-background-900 to-primary-950/40">
        <div className="grid grid-cols-1 gap-8 p-6 md:p-9 lg:grid-cols-[1.3fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-400">
              <i className="ri-shield-star-line"></i>
              关于麻豆免费视频
            </span>
            <h2 className="mt-4 text-2xl font-bold text-foreground-50 md:text-3xl">
              免费高清影视，随时随地想看的都在这
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
              麻豆免费视频致力于提供丰富的免费视频影视内容，涵盖电影、电视剧和综艺节目三大分类。我们以清晰的分类、便捷的筛选与搜索，帮助影视爱好者快速找到想看的内容，体验流畅、舒适的在线观影。
            </p>
            <p className="mt-3 text-xs text-foreground-500">
              温馨提示：本站为演示站点，播放功能为演示性质，真实播放功能待接入，影视资料与封面均为虚拟内容。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {STATS.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-800 bg-background-950/60 p-4 transition-colors hover:border-primary-500/50 md:p-5">
                <i className={`${stat.icon} text-xl text-primary-400`}></i>
                <p className="font-heading mt-3 text-xl font-bold text-foreground-50 md:text-2xl">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}